import PropTypes from 'prop-types';
import { useState, useEffect } from "react";
import FormModal from "../../../../core/ui/components/FormModal";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";

import dataReglas from "../../data.json";
import { Controller, useForm } from "react-hook-form";
import { toast } from "../../../../core/helpers/message-helper";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { crearOEditarRegla } from "../../services/nomina-reglas-service";
import { selectTurnosSedes } from '../../../NominaTurnos/services/nomina-turnos-service';

const FormReglasTurnos = ({ onCreated, modalState }) => {
    const [turnosSedes, setTurnosSedes] = useState([]);
    // Periodo de tiempo de turnos
    const [isWeekly, setIsWeekly] = useState(modalState.data.turnosSemanales);
    const defaultValues = buildDefaultValues(modalState.data.regla);

    const form = useForm({ defaultValues });

    function buildDefaultValues(regla) {
        const trabajaFestivosRegla = {
            label: regla.trabaja_festivos == 1 ? "SI" : "NO",
            value: regla.trabaja_festivos == 1 ? 1 : 0,
        };

        const turnosSemana = dataReglas.TURNOS_SEMANA.reduce((prev, item) => {
            prev[item.name] = {
                value:
                    regla != null && regla[item.name] ? regla[item.name] : "",
                label:
                    regla != null && regla[item.labelField]
                        ? regla[item.labelField]
                        : "",
            };
            return prev;
        }, {});

        return {
            ...turnosSemana,
            id: regla.id ?? "",
            horas_dia: regla.horas_dia ?? "",
            trabaja_festivos: trabajaFestivosRegla,
            nombre: regla.nombre ? regla.nombre : "",
            dias_descanso_mes: regla.dias_descanso_mes ?? 0,
            intervalo_descanso: regla.intervalo_descanso ?? 0,
            max_horas_extra_dia: regla.max_horas_extra_dia ?? "",
            dias_descanso_semana: regla.dias_descanso_semana ?? 0,
            max_horas_extra_semana: regla.max_horas_extra_semana ?? "",
            max_horas_turnos_seguidos: regla.max_horas_turnos_seguidos ?? "",
            turno_sede_semana_id: {
                label: regla.turnoSedeS,
                value: regla.turno_sede_semana_id,
            },
            turno_sede_sabado_id: {
                label: regla.turnoSedeZ,
                value: regla.turno_sede_sabado_id,
            },
            turno_sede_domingo_id: {
                label: regla.turnoSedeD,
                value: regla.turno_sede_domingo_id,
            },
        };
    }

    useEffect(async () => {
        const resp = await selectTurnosSedes();
        if (!resp.status) return toast.error(resp.message);

        setTurnosSedes(
            resp.data.map((turno) => {
                return {
                    label: turno.info_asignacion_turno,
                    value: turno.id,
                };
            })
        );
    }, []);

    useEffect(
        () => setIsWeekly(modalState.data.turnosSemanales),
        [modalState.data.turnosSemanales]
    );

    useEffect(
        () => form.reset(buildDefaultValues(modalState.data.regla)),
        [modalState.data.regla]
    );

    async function onSubmit(data) {
        const weekValues = dataReglas.TURNOS_SEMANA.reduce((prev, day) => {
            prev[day.name] = data[day.name].value;
            return prev;
        }, {});

        const resp = await crearOEditarRegla({
            ...data,
            ...weekValues,
            turno_sede_semana_id: data.turno_sede_semana_id.value,
            turno_sede_sabado_id: data.turno_sede_sabado_id.value,
            turno_sede_domingo_id: data.turno_sede_domingo_id.value,
            trabaja_festivos: data.trabaja_festivos?.value ?? 0,
        });

        resp.status ? onCreated(resp) : toast.error(resp.message);
    }

    return (
        <FormModal
            size="xl"
            form={form}
            id="formReglas"
            onSubmit={onSubmit}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() =>
                modalState.set({
                    show: false,
                    data: { ...modalState.data, regla: {} },
                })
            }
        >
            <Row>
                <Controller
                    name="idRegla"
                    control={form.control}
                    render={({ field }) => (
                        <Input
                            id="id"
                            value={field.value ?? ""}
                            type="hidden"
                            {...field}
                        />
                    )}
                />
                <Col lg={4}>
                    <InputController
                        type="text"
                        label="Nombre de la regla"
                        name="nombre"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas laborales del día"
                        name="horas_dia"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        rules={dataReglas.REQUIRED_RULE}
                        label="¿Trabaja festivos?"
                        name="trabaja_festivos"
                        options={dataReglas.YES_OR_NOT_OPTIONS}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Días de descanso a la semana adicionales"
                        name="dias_descanso_semana"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Límite de días adicionales de descanso al mes"
                        name="dias_descanso_mes"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Intérvalo de tiempo para días de descanso adicionales"
                        name="intervalo_descanso"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas turnos seguidos"
                        name="max_horas_turnos_seguidos"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas extras (dia)"
                        name="max_horas_extra_dia"
                        control={form.control}
                        errors={form.formState.errors}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas extras (semana)"
                        name="max_horas_extra_semana"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={dataReglas.REQUIRED_RULE}
                    />
                </Col>
                <h4 className="text-center w-100">ESTABLECER TURNOS</h4>
                <Col lg={12} className="justify-content-center d-flex">
                    <FormGroup className="mr-5">
                        <Input
                            type="radio"
                            name="fk_turnos"
                            value="weekly"
                            id="weekly"
                            onClick={() => setIsWeekly(true)}
                            defaultChecked={isWeekly}
                        />
                        <Label for="weekly"> Semana</Label>
                    </FormGroup>
                    <FormGroup>
                        <Input
                            type="radio"
                            name="fk_turnos"
                            value="daily"
                            id="daily"
                            onClick={() => setIsWeekly(false)}
                            defaultChecked={!isWeekly}
                        />
                        <Label for="daily"> Diario</Label>
                    </FormGroup>
                </Col>
                {isWeekly ? (
                    <Col lg={4}>
                        <SelectController
                            label="Turno Semana"
                            name="turno_sede_semana_id"
                            control={form.control}
                            errors={form.formState.errors}
                            rules={dataReglas.REQUIRED_RULE}
                            options={turnosSedes}
                        />
                    </Col>
                ) : (
                    dataReglas.TURNOS_SEMANA.map((turnoSe) => {
                        return (
                            <Col lg={4} key={turnoSe.name}>
                                <SelectController
                                    name={turnoSe.name}
                                    label={turnoSe.label}
                                    options={turnosSedes}
                                    control={form.control}
                                    errors={form.formState.errors}
                                    rules={dataReglas.REQUIRED_RULE}
                                />
                            </Col>
                        );
                    })
                )}
                <Col lg={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        label="Turno Sábado"
                        options={turnosSedes}
                        rules={dataReglas.REQUIRED_RULE}
                        name="turno_sede_sabado_id"
                    />
                </Col>
                <Col lg={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        label="Turno Domingo"
                        options={turnosSedes}
                        rules={dataReglas.REQUIRED_RULE}
                        name="turno_sede_domingo_id"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormReglasTurnos.propTypes = {
    modalState: PropTypes.object,
    onCreated: PropTypes.func
}

export default FormReglasTurnos;
